"use strict";
var hlp = require('common/helpers');
var urls = require('common/urls');
var popup = require('common/popup');
var controller = function($scope, $q, $http, $filter, Flash, $uibModal) {
  var resultMap = null;
  var setupTable = function() {
    $scope.config = {
      itemsPerPage: 25,
      maxPages: 5,
      paginatorLabels: {
        stepBack: '‹',
        stepAhead: '›',
        jumpBack: '«',
        jumpAhead: '»',
        first: 'Erste',
        last: 'Letzte'
      }
    };
  };
  var loadSchema = function() {
    var deferred = $q.defer();
    var params = {};
    $http.get('/api/search/schema.json', {params: params}).success(function(data, status, headers, config) {
      if (!hlp.isSet($scope.schema)) {
        $scope.schema = data.description;
        $scope.workSchema = data.work;
      }
      deferred.resolve();
    }).catch(function(data, status, headers, config) {
      deferred.reject();
    });
    return deferred.promise;
  };
  var loadData = function() {
    $scope.isLoading = true;
    var deferred = $q.defer();
    var collectionId = null;
    if (hlp.isSet($scope.filterCollection)) {
      collectionId = $scope.filterCollection._id;
    }
    var params = {
      fieldname: $scope.fieldname,
      entitytype: $scope.entitytype,
      query: $scope.query,
      caseInsensitive: $scope.caseInsensitive,
      collectionId: collectionId,
      isRegex: $scope.isRegex
    };
    $http.get('/api/search.json', {params: params}).success(function(data, status, headers, config) {
      $scope.result = transformResult(data.list);
      resultMap = buildResultMap($scope.result);
      $scope.orderedResult = orderBy($scope.result);
      $scope.filteredResult = $scope.result;
      $scope.refreshTableFields();
      deferred.resolve();
      $scope.isLoading = false;
    }).catch(function(data, status, headers, config) {
      $scope.isLoading = false;
      var message = '<strong>Interner Fehler beim Suchen!</strong>.';
      Flash.create('danger', message, 5000, {}, true);
      deferred.reject();
    });
    return deferred.promise;
  };
  $scope.refreshTableFields = function() {
    $scope.fields = getFieldsForTable($scope.entitytype, $scope.editFieldname);
    $scope.editFieldTerm = {};
    $scope.editReplace = "";
    $scope.editFieldThesaurus = undefined;
    if ($scope.editFieldname === undefined) {
      return false;
    }
    for (var i = 0; i < $scope.fields.length; ++i) {
      var f = $scope.fields[i];
      if (f.name == $scope.editFieldname) {
        if (f.thesaurus !== undefined) {
          $scope.editFieldThesaurus = f.thesaurus;
          break;
        }
      }
    }
    $scope.fieldHasThesaurus = $scope.editFieldThesaurus !== undefined;
  };
  $scope.initTerm = function() {
    $scope.editFieldTerm = {};
  };
  $scope.typeaheadValue = function(term) {
    if (typeof(term) == 'undefined') {
      return $scope.editFieldTerm.shortName;
    } else {
      if (typeof(term) == 'string') {
        $scope.editFieldTerm.shortName = term;
        delete($scope.editFieldTerm.id);
      } else {
        $scope.editFieldTerm.shortName = term.shortName;
        $scope.editFieldTerm.id = term.id;
      }
    }
  };
  var getThesauri = function(query) {
    var getDropdownDisplay = function(term) {
      if (term === undefined) {
        return;
      }
      var ret = term.defaultName + " (" + term.id + ") ";
      if (term.longName && term.longName != term.defaultName) {
        ret += term.longName;
      }
      return ret;
    };
    return $http.get('/api/thesaurus/' + $scope.editFieldThesaurus + '/term.json?no_categories=true&query=' + query).then(function(response) {
      var terms = response.data.terms;
      terms.forEach(function(term) {
        return term.dropdownDisplay = getDropdownDisplay(term);
      });
      return terms;
    });
  };
  $scope.getThesauri = getThesauri;
  var transformResult = function(result) {
    var transformedResult = [];
    if (hlp.isSet(result)) {
      for (var i = 0; i < result.length; ++i) {
        var entity = result[i].entity;
        entity.id = result[i].id;
        entity.nr = parseInt(result[i].nr);
        entity.archivnr = result[i].archivnr;
        entity.primaryPicture = result[i].primaryPicture;
        entity.subject = result[i].subject;
        entity.state = result[i].state;
        entity.author = result[i].author;
        transformedResult.push(entity);
      }
    }
    return transformedResult;
  };
  var getEntryKey = function(entry) {
    if (entry.nr)
      return entry.nr + ':' + entry.id;
    else
      return entry.archivnr;
  };
  var buildResultMap = function(resultList) {
    var map = {};
    for (var i = 0; i < resultList.length; ++i) {
      var entry = resultList[i];
      map[getEntryKey(entry)] = entry;
    }
    return map;
  };
  $scope.thumbnailUrl = function(dianr, size) {
    if (typeof size == 'undefined') {
      size = 32;
    }
    return urls.thumbnailUrl(dianr, size, size);
  };
  $scope.updateResult = function() {
    $scope.filteredResult = $filter("filter")($scope.orderedResult, $scope.filterquery);
    for (var i = 0; i < $scope.filteredResult.length; i++) {
      if ($scope.filteredResult[i].selected != true) {
        $scope.tableOptions.toggleAll = false;
        return;
      }
    }
    $scope.tableOptions.toggleAll = true;
  };
  $scope.popup = function(archivnr, dianr) {
    popup.open(archivnr, dianr);
  };
  $scope.orderBy = function(name) {
    if ($scope.activeCol == name) {
      if ($scope.activeOrder == false) {
        $scope.activeOrder = true;
      } else {
        $scope.activeOrder = false;
      }
    }
    $scope.orderedResult = orderBy($scope.result, name, $scope.activeOrder);
    $scope.updateResult();
    $scope.activeCol = name;
  };
  var orderBy = function(list, name, reverse) {
    return $filter('orderBy')(list, [name], reverse);
  };
  var getFieldsForTable = function(entitytype, fieldname) {
    var fields = [];
    if (entitytype) {
      if (entitytype != "work") {
        var schemaElem = $scope.schema.entities[entitytype];
        if (hlp.isSet(schemaElem)) {
          for (var fieldName in schemaElem.fields) {
            fields.push({
              name: fieldName,
              label: schemaElem.fields[fieldName].label,
              thesaurus: schemaElem.fields[fieldName].thesaurus
            });
          }
        }
      } else {
        var field = {
          name: fieldname,
          label: $scope.workSchema[fieldname].label
        };
        if ($scope.editFieldname) {
          fields.push({
            name: $scope.editFieldname,
            label: $scope.workSchema[$scope.editFieldname].label,
            thesaurus: $scope.workSchema[$scope.editFieldname].thesaurus
          });
        } else {
          fields.push(field);
        }
      }
    }
    return fields;
  };
  var getEntities = function() {
    var entities = [];
    entities.push({
      name: "work",
      label: "Werk"
    });
    for (var entityName in $scope.schema.entities) {
      entities.push({
        name: $scope.schema.entities[entityName].name,
        label: $scope.schema.entities[entityName].label
      });
    }
    return entities;
  };
  $scope.updateEntityFields = function() {
    if ($scope.entitytype != "work") {
      var entity = $scope.schema.entities[$scope.entitytype];
      if (hlp.isSet(entity)) {
        $scope.entityFields = entity.fields;
      }
    } else {
      $scope.entityFields = $scope.workSchema;
    }
    $scope.entityFields = _.orderBy($scope.entityFields, 'label');
  };
  $scope.submit = function() {
    $scope.result = [];
    loadData();
    $scope.filterquery = "";
    $scope.editFieldname = $scope.fieldname;
  };
  $scope.edit = function() {
    var replacement = $scope.editReplace;
    var thesaurusId = undefined;
    if ($scope.editFieldTerm !== undefined && $scope.editFieldTerm.shortName) {
      replacement = $scope.editFieldTerm.shortName;
      thesaurusId = $scope.editFieldTerm.id;
    }
    var params = {
      entities: $scope.selectedIds,
      fieldName: $scope.editFieldname,
      mode: $scope.editMode,
      pattern: $scope.editQuery,
      replacement: replacement,
      thesaurusId: thesaurusId
    };
    $scope.isLoading = true;
    $http.post('/api/search/edit.json', params).then(function(response) {
      var count = response.data.count;
      updateResultList(response.data.list);
      var message = '<strong>Erfolgreich bearbeitet. ' + count + ' Entitäten geändert </strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.isLoading = false;
    }, function(response) {
      var message = '<strong>Fehler beim bearbeiten!</strong>.';
      Flash.create('danger', message, '');
      $scope.isLoading = false;
    });
  };
  var updateResultList = function(newResults) {
    for (var i = 0; i < newResults.length; ++i) {
      var entry = newResults[i];
      var oldEntry = resultMap[getEntryKey(entry)];
      if (!oldEntry) {
        console.error("Could not find existing entry " + getEntryKey(entry));
        continue;
      }
      for (var k in entry.entity) {
        oldEntry[k] = entry.entity[k];
      }
    }
  };
  $scope.calcSelectedCount = function() {
    $scope.selectedCount = 0;
    for (var i = 0; i < $scope.result.length; i++) {
      if ($scope.result[i].selected) {
        $scope.selectedCount += 1;
      }
    }
  };
  $scope.toggleSelectItem = function() {
    $scope.calcSelectedCount();
  };
  $scope.toggleSelectAll = function(value) {
    for (var i = 0; i < $scope.filteredResult.length; i++) {
      $scope.filteredResult[i].selected = value;
    }
    $scope.calcSelectedCount();
  };
  $scope.replace = function() {
    var ids = $filter('filter')($scope.result, function(f) {
      if (f.selected == true) {
        return true;
      }
      return false;
    });
    $scope.selectedIds = ids;
    $scope.edit();
  };
  $scope.initCollections = function() {
    var deferred = $q.defer();
    var params = {"per_page": 0};
    $http.get('/api/collection.json', {params: params}).success(function(data, status, headers, config) {
      $scope.collections = data.collections;
      $scope.filteredCollections = $scope.collections;
      deferred.resolve();
    }).catch(function(data, status, headers, config) {
      deferred.reject();
    });
    return deferred.promise;
  };
  $scope.selectCollection = function(collection) {
    $scope.showCollection = false;
    if ($scope.activeField == 'editor') {
      $scope.editorCollection = collection;
    } else if ($scope.activeField == 'filter') {
      $scope.filterCollection = collection;
    }
  };
  $scope.filterCollections = function() {
    $scope.filteredCollections = $filter("filter")($scope.collections, $scope.collectionsFilterQuery);
  };
  var newCollection = function() {
    var works = [];
    for (var i = 0; i < $scope.result.length; i++) {
      if ($scope.result[i].selected) {
        works.push($scope.result[i].archivnr);
      }
    }
    var params = {
      name: $scope.collectionName,
      beschreibung: $scope.collectionDescription,
      flags: ["PRIVATE"],
      works: works
    };
    $http.post('/api/collection.json', params).then(function(response) {
      var message = '<strong>Erfolgreich angelegt.</strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.isLoading = false;
    }, function(response) {
      var message = '<strong>Fehler beim bearbeiten!</strong>.';
      Flash.create('danger', message, 0, {}, true);
      $scope.isLoading = false;
    });
  };
  var updateCollection = function() {
    var id = $scope.editorCollection._id.$oid;
    var works = $scope.editorCollection.works;
    for (var i = 0; i < $scope.result.length; i++) {
      if ($scope.result[i].selected) {
        var archivnr = $scope.result[i].archivnr;
        if (!hlp.isSet(works[archivnr])) {
          works.push(archivnr);
        }
      }
    }
    $http.post('/api/collection/' + id + '.json', $scope.editorCollection).then(function(response) {
      var message = '<strong>Erfolgreich aktualisiert.</strong>.';
      Flash.create('success', message, 5000, {}, true);
      $scope.isLoading = false;
    }, function(response) {
      var message = '<strong>Fehler beim bearbeiten!</strong>.';
      Flash.create('danger', message, 0, {}, true);
      $scope.isLoading = false;
    });
  };
  $scope.saveCollection = function() {
    if ($scope.editCollection == 'new') {
      newCollection();
    } else if ($scope.editCollection == 'edit') {
      updateCollection();
    }
  };
  var init = function() {
    $scope.result = [];
    $scope.orderedResult = [];
    $scope.filteredResult = [];
    $scope.fields = [];
    $scope.replaceCount = 0;
    $scope.tableOptions = {toggleAll: false};
    $scope.editCollection = 'new';
    setupTable();
    loadSchema().then(function() {
      $scope.entities = getEntities();
    });
  }();
  $scope.caseInsensitive = true;
  $scope.isRegex = false;
};
module.exports = controller;
